
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import axiosInstance from '../../../api/axiosInstance';
// Create an async thunk for the API call
export const changePassword = createAsyncThunk(
  'changePassword/execute',
  async ({ oldPassword, newPassword, newPasswordConfirm, id, type, token }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        '/api/Common/ChangePasswordByOldPassword',
        {
          oldPassword:oldPassword,
          newPassword:newPassword,
          newPasswordConfirm:newPasswordConfirm,
          id:id,
          type:1,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      ); 
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const changePasswordSlice = createSlice({
  name: 'changePassword',
  initialState: {
    loading: false,
    success: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(changePassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changePassword.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default changePasswordSlice.reducer;
